export const DEFAULT_RESERVATION_MAX_BOOKING_SIZE = 10;
export const RESERVATION_VISIBLE_GUEST_BUTTONS = 10;

export function getEffectiveReservationMaxBookingSize(maxBookingSize?: number | null): number {
  if (maxBookingSize == null || Number(maxBookingSize) < 1) {
    return DEFAULT_RESERVATION_MAX_BOOKING_SIZE;
  }

  return Number(maxBookingSize);
}

export function getPrimaryGuestButtonCount(maxBookingSize: number): number {
  return Math.min(RESERVATION_VISIBLE_GUEST_BUTTONS, maxBookingSize);
}

export function getExtraGuestCounts(maxBookingSize: number): number[] {
  if (maxBookingSize <= RESERVATION_VISIBLE_GUEST_BUTTONS) {
    return [];
  }

  return Array.from(
    { length: maxBookingSize - RESERVATION_VISIBLE_GUEST_BUTTONS },
    (_, index) => index + RESERVATION_VISIBLE_GUEST_BUTTONS + 1,
  );
}

export function clampReservationGuestCount(quantity: number | null | undefined, maxBookingSize: number): number {
  const normalizedQuantity = Number(quantity);
  if (!Number.isFinite(normalizedQuantity) || normalizedQuantity < 1) {
    return 1;
  }

  return Math.min(normalizedQuantity, maxBookingSize);
}

export function createEmptyGuestSearchState<T = unknown>(maxBookingSize: number): {
  guestQueries: string[];
  guestSearchResults: T[][];
} {
  return {
    guestQueries: Array.from({ length: maxBookingSize }, () => ""),
    guestSearchResults: Array.from({ length: maxBookingSize }, () => []),
  };
}

export function resizeGuestSearchState<T = unknown>(
  guestQueries: string[],
  guestSearchResults: T[][],
  maxBookingSize: number,
): { guestQueries: string[]; guestSearchResults: T[][] } {
  return {
    guestQueries: Array.from({ length: maxBookingSize }, (_, index) => guestQueries[index] ?? ""),
    guestSearchResults: Array.from({ length: maxBookingSize }, (_, index) => guestSearchResults[index] ?? []),
  };
}
